import { Component, PLATFORM_ID, Inject, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { map, delay, withLatestFrom } from 'rxjs/operators';
import { LayoutService } from './shared/services/layout.service';
import { filter, take, tap } from 'rxjs';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
	// For Progressbar
	isUpdateAvailable = false;

	constructor(
		@Inject(PLATFORM_ID) private platformId: Object,
		private loader: LoadingBarService,
		private layoutService: LayoutService,
		private swUpdate: SwUpdate
	) {
		const loaders = this.loader.value$.pipe(
			delay(1000),
			withLatestFrom(this.loader.value$),
			map(v => v[1])
		);
		this.layoutService.initLanguage();
	}

	ngOnInit() {
		if (this.swUpdate.isEnabled) {
			this.swUpdate.versionUpdates
				.pipe(
					// Filter for the specific event type that signals a new version is ready
					filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'),
					take(1),
					tap(() => {
						this.isUpdateAvailable = true;
						console.log('Update detected! Displaying notification and waiting 5 seconds...');
					}),
					// 5-second delay before activating the new version
					delay(5000)
				)
				.subscribe(() => {
					console.log('5 seconds elapsed. Activating update and reloading...');
					// Force the Service Worker to activate the new version
					// and reload the page to ensure the user gets the new index.html
					this.swUpdate.activateUpdate().then(() => {
						window.location.reload();
					});
				});
		}
	}
}
